import React from 'react';
import styled from '@benzinga/themetron';

export const LiveBarIndicator = () => {
  return (
    <LiveBarIndicatorContainer className="live-indicator-container">
      <div className="indicator uppercase font-bold text-white flex items-center">
        <div
          aria-hidden="true"
          className="indicator-icon blink w-[15px] h-[15px] bg-white rounded-full inline-block mr-2"
        ></div>
        <span className="indicator-text mt-0.5">Live</span>
      </div>
    </LiveBarIndicatorContainer>
  );
};

const LiveBarIndicatorContainer = styled.div`
  &.live-indicator-container {
    .indicator {
      font-family: sans-serif;
      background: #e92229;
      padding: 6px 7px;
      border-radius: 6px;
      height: 36px;
    }

    .blink {
      animation: blinker 1.2s cubic-bezier(0.5, 0, 1, 1) infinite alternate;
    }
    @keyframes blinker {
      from {
        opacity: 0.9;
      }
      to {
        opacity: 0.1;
      }
    }
  }
`;
